module.exports = __webpack_public_path__ + "app-static/img/ex-4.c31c51da.png";